/**
 * IBS detail page -- /twin/ibs/:id (P2.7.e).
 *
 * Thin wrapper around EntityDetailLayout. The resilience chip is now
 * live-read (P272.4); P275 adds the IBS story hub (admission / tolerance /
 * MVB / resilience / obligations / scenarios) under the header.
 */
import { useParams } from "react-router-dom";

import { EntityDetailLayout } from "twin/entity/EntityDetailLayout";
import { IBSDependencyLayers } from "twin/entity/IBSDependencyLayers";
import { RestsOnFindingsPanel } from "twin/entity/RestsOnFindingsPanel";
import { IBSStoryHub } from "twin/entity/IBSStoryHub";
import { IBSGroupNote } from "twin/entity/IBSGroupNote";
import { ThreadStrip } from "shared/thread/ThreadStrip";
import { IBSFirstMeetings } from "twin/entity/IBSFirstMeetings";
import { OwnerIBSIncidentStrip } from "twin/entity/OwnerIBSIncidentStrip";
import { OperatorTolerancePanel } from "twin/entity/OperatorTolerancePanel";
import { OwnerIBSPanel } from "twin/entity/OwnerIBSPanel";

const NULL_CHIPS = {
  resilience: null,
  blast_ibs_count: null,
  process_count: null,
  obligation_count: null,
} as const;

export function IBSDetail() {
  const { id } = useParams<{ id: string }>();
  return (
    <EntityDetailLayout
      kind="ibs_service"
      entityId={id}
      chips={NULL_CHIPS}
      story={
        <>
          {/* D6 -- what is happening to this service RIGHT NOW, for the
              person accountable for it. The finding page had the clock;
              his own service's page said nothing, so he had to notice a
              number in a chip row and go looking. */}
          <OwnerIBSIncidentStrip ibsId={id} />
          <IBSStoryHub ibsId={id} />
          {/* Round 20 U4 -- open findings on what it rests on. */}
          <RestsOnFindingsPanel ibsId={id} />
          {/* Round 16 O5 -- what the GROUP chip means for this service. */}
          <IBSGroupNote ibsId={id} />
          {/* Stitching review 5.5 -- what the chips above mean, taught once. */}
          <IBSFirstMeetings ibsId={id} />
          {/* Stitching review 5.2 -- the regulator's thread through this
              service: expected, have, judged, decided, proved. */}
          <ThreadStrip ibsId={id} />
          {/* B4: only renders for the person the estate says owns it. */}
          {/* Round 17 R3 -- the thread's tolerance step lands here. */}
          <div id="tolerance">
            <OwnerIBSPanel ibsId={id} />
            {/* A3: the same form for the Resilience Lead, who the API has
                always admitted but who had no route to it. */}
            <OperatorTolerancePanel ibsId={id} />
          </div>
          {/* 4.1 -- the story hub above says whether this service is
              governed; this says what it actually rests on. */}
          <IBSDependencyLayers ibsId={id} />
        </>
      }
    />
  );
}
